<label style="color: white;">_</label>
<p-floatLabel>
  <p-multiSelect
    [options]="genreMusicalService.genreMusicalDataList"
    [(ngModel)]="objChant.genreMusicalListSelected"
    optionLabel="name"
    [formControl]="control"
    [filter]="true"
    display="chip"
    [showClear]="true"
    [disabled]="false"
    placeholder="- Select -" Width="100%" styleClass="width: 100%;"
    (onChange)="onGenreDataChange($event)">
    <ng-template let-country pTemplate="item">
        <div class="flex align-items-center gap-2">
            <div>{{ country.name }}</div>
        </div>
    </ng-template>
    <ng-template let-country pTemplate="footer">
        <div class="py-2 px-3">
            <b>
            {{ objChant.genreMusicalListSelected ? objChant.genreMusicalListSelected.length : 0 }}
            </b>
            item{{ (objChant.genreMusicalListSelected ? objChant.genreMusicalListSelected.length : 0) > 1 ? 's' : '' }} selected.
        </div>
    </ng-template>
  </p-multiSelect>
  <label for="float-label">Genre
    <span *ngIf="genreMusicalService.genreMusicalDataList.length>0">(<b>{{genreMusicalService.genreMusicalDataList.length}}</b> items)</span> -
    <b>
    {{ objChant.genreMusicalListSelected ? objChant.genreMusicalListSelected.length : 0 }}
    </b>
    item{{ (objChant.genreMusicalListSelected ? objChant.genreMusicalListSelected.length : 0) > 1 ? 's' : '' }} selected.
  </label>
</p-floatLabel>

<div class="clearfix card1" *ngIf="genreEtStyleMusicalDataDtoListSelected">
  @for (genre of objChant.genreMusicalListSelected; track genre) {
    <span class="chip form-chantUser"><p-chip [label]="genre.name" [removable]="false" styleClass="font-size:9px" /></span>
  }
</div>
